import { useTranslation } from "react-i18next";
import { AdditionalServiceItemTitle } from "@features/AdditionalServices/components/AdditionalServiceItemTitle/AdditionalServiceItemTitle";
import { ButtonLink } from "@components/Button";
import { CMSImage } from "@components/CMSImage/CMSImage";
import { parseHtml } from "@components/HTMLParser/utils";
import { Link } from "@components/Link/Link";
import type { IAdvert } from "@services/adverts/types";

interface IAdditionalServiceAdvertProps {
  advert: IAdvert;
}

export const AdditionalServiceAdvert: React.FC<
  IAdditionalServiceAdvertProps
> = ({ advert }) => {
  const { t } = useTranslation();

  const isImageOnly =
    advert.additionalServicePageImage?.url &&
    !advert.additionalServicePageTitle;

  if (isImageOnly) {
    return (
      <Link
        to={advert.link}
        className="group flex w-full cursor-pointer items-center justify-center overflow-hidden rounded-xl border border-[#DEDEDE] bg-base-white shadow-sm"
      >
        <CMSImage image={advert.additionalServicePageImage} />
      </Link>
    );
  }

  return (
    <div className="group w-full overflow-hidden rounded-xl border border-[#DEDEDE] bg-base-white shadow-sm">
      <div className="relative h-[191px] border-b border-[#DEDEDE] p-0">
        <CMSImage
          image={advert.additionalServicePageImage}
          className="z-2 h-full w-full object-contain"
        />
      </div>
      <div
        className="flex h-[calc(100%-191px)] flex-row items-center justify-between p-6"
        style={{ backgroundColor: advert.additionalServicePageBackgroundColor }}
      >
        <div className="flex h-full w-full flex-col justify-between gap-2">
          <AdditionalServiceItemTitle
            title={advert.additionalServicePageTitle ?? ""}
          />
          <div className="text-sm">
            {parseHtml(advert.additionalServicePageDescription ?? "")}
          </div>
          <ButtonLink href={advert.link} target="_blank" className="w-full">
            {t("advert.actions.getOffer")}
          </ButtonLink>
        </div>
      </div>
    </div>
  );
};
